import {confirmPopup, ConfirmPopup} from "primereact/confirmpopup";
import React, {useEffect, useRef, useState} from "react";
import {useFormik} from "formik";
import {Checkbox} from "primereact/checkbox";
import {Button} from "primereact/button";
import FormGroup from "../components/FormGroup";
import {SelectButton} from "primereact/selectbutton";
import {InputText} from "primereact/inputtext";
import {Calendar} from "primereact/calendar";
import PhoneInput from "react-phone-input-2";
import Loader from "../components/Loader";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import {ClientService} from "../services/ClientService";
import {Toast} from "primereact/toast";
import {useSelector} from "react-redux";

export default function ClientParents() {

    const locationParams = useParams()
    const currentDepartment = useSelector(function (state) {
        return state.currentDepartment
    });
    let navigation = useNavigate();
    const context = useOutletContext()

    const formik = useFormik({
        validate: (data) => {
            let errors = {}

            let contactsCount = 0
            data.contacts.map((contact, contactIndex) => {
                if (contact) {
                    contactsCount++;

                    if (!contact.name) {
                        errors['contact_' + contactIndex + '_name'] = 'Обязательное поле!'
                    }

                    let hasPhones = false
                    contact.phones.map((phone, phoneIndex) => {
                        if (phone.phone) {
                            hasPhones = true
                        }
                    })
                    if (!hasPhones) {
                        errors['contact_' + contactIndex + '_phone'] = 'Обязательное поле!'
                    }

                }

            })
            if (!contactsCount) {
                errors.contacts = 'Должно быть минимум одно контактное лицо!'
            }

            return errors

        },
        onSubmit: (data) => {
            // setIsLoaded(false)
            setIsLoading(true)
            if(client.id) {
                ClientService.UpdateParents(client.id, data).then((r) => {
                    context.updateUser()
                    toast.current.show({severity: 'success', summary: 'Данные успешно сохранены!'});

                })
            } else {
                ClientService.Create({department_id: currentDepartment, type: locationParams.type}).then((response) => {
                    if(response && response.id){
                        ClientService.UpdateParents(response.id, data).then((r) => {
                            navigation('/client/' + response.id)
                            // context.updateUser()
                            toast.current.show({severity: 'success', summary: 'Клиент успешно создан!'});
                        })
                    }
                })
            }
        }
    })

    const [client, setClient] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const toast = useRef()

    const handleMainParent = (isChecked, k) => {

        if (isChecked) {
            formik.values.contacts.map((contact, ck) => {
                if (contact) {
                    if (k !== ck && contact.main) {
                        formik.setFieldValue('contacts.' + ck + '.main', 0)
                    }
                }
            })
        }
        formik.setFieldValue('contacts.' + k + '.main', isChecked)
    }


    const addContact = () => {
        let data = [{
            name: '',
            main: false,
            type: '',
            phones: [
                {
                    phone: ''
                }
            ],
            emails: [
                {
                    email: ''
                }
            ],
            work: '',
            birthday: '',
            car_mark: '',
            car_number: ''
        }];


        // formik.resetForm()
        formik.setValues({contacts: [...formik.values.contacts, ...data]}, false);
    }

    const handlerRemoveContact = (event, contactIndex) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Вы хотите удалить контактное лицо?',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => {
                let fv = formik.values
                delete fv.contacts[contactIndex]
                // console.log(fv)
                // formik.resetForm()
                formik.setValues(fv, false)
            },
            acceptLabel: 'Да',
            rejectLabel: 'Нет!'
        });

    }

    const handlerAddContactPhone = (contactIndex) => {
        formik.setFieldValue('contacts.' + contactIndex + '.phones.' + formik.values.contacts[contactIndex].phones.length, {
            phone: '',
            phone_code: ''
        })
    }


    const handlerRemoveContactPhone = (contactIndex, phoneIndex) => {
        let fv = formik.values
        delete fv.contacts[contactIndex].phones[phoneIndex]
        formik.setValues(fv, false)
    }
    const handlerAddContactEmail = (contactIndex) => {
        formik.setFieldValue('contacts.' + contactIndex + '.emails.' + formik.values.contacts[contactIndex].emails.length, {
            email: ''
        })
    }

    const handlerRemoveContactEmail = (contactIndex, emailIndex) => {
        let fv = formik.values
        delete fv.contacts[contactIndex].emails[emailIndex]
        formik.setValues(fv, false)
    }

    const isFormFieldInvalid = (name, touched = '') => {
        if (touched === '') {
            return !!(formik.touched[name] && formik.errors[name]);
        } else {
            let a
            if (formik.touched && Object.keys(formik.touched).length > 0) {
                a = touched.split('.').reduce((acc, el) => {
                    if (acc) {
                        return acc[el]
                    }
                }, formik.touched);
            } else {
                a = false
            }
            return !!(a && formik.errors[name]);
        }
    }

    const getFormErrorMessage = (name, touched = '') => {
        return isFormFieldInvalid(name, touched) ? <small className="p-error">{formik.errors[name]}</small> :
            <small className="p-error">&nbsp;</small>;
    };

    useEffect(() => {
        let contacts = []
        if (client && client.contacts) {
            client.contacts.map((contact) => {

                let phones = []
                if (contact.phones.length > 0) {
                    contact.phones.map((phone) => {
                        phones.push({
                            phone: phone.phone_code + phone.phone,
                            id: phone.id
                        })
                    })
                } else {
                    phones.push({
                        phone: ''
                    })
                }

                let emails = []
                if (contact.emails.length > 0) {
                    contact.emails.map((email) => {
                        emails.push({
                            email: email.email,
                            id: email.id
                        })
                    })
                } else {
                    emails.push({
                        email: ''
                    })
                }

                let data = {
                    id: contact.id,
                    name: contact.name,
                    main: !!contact.main,
                    type: contact.type,
                    phones: phones,
                    emails: emails,
                    work: contact.work,
                    birthday: contact.birthday ? new Date(contact.birthday) : '',
                    car_mark: contact.car_mark,
                    car_number: contact.car_number
                };

                contacts.push(data)
            })
            formik.setValues({contacts: contacts}, false)
            setIsLoaded(true)
            setIsLoading(false)
        }
        // if(client === true){
        //     formik.setValues({contacts: {}}, false)
        //     // addContact()
        //     setIsLoaded(true)
        //     setIsLoading(false)
        // }
    }, [client]);

    useEffect(() => {

        if(context === true) {
            setClient({contacts: []})
        } else {
            setClient(context)
        }
    }, [context]);

    return (
        <>
            <ConfirmPopup/>
            <div className="card">
                <div className="card-body">
                    <Toast ref={toast}/>

                    <form id={'parents-form'} className={'base-form'} onSubmit={formik.handleSubmit}>
                        <h3 className={'m-b-10'}>Контакты</h3>

                        {getFormErrorMessage('contacts')}
                        {isLoaded ?
                            <div className="d-flex flex-column gap-3 p-t-10">
                                {formik.values.contacts.map((contact, k) => {
                                    if (contact) {
                                        return (
                                            <div className={'card card-absolute'}>
                                                <div className="card-header">
                                                    <div className="d-flex align-items-center">
                                                        <Checkbox name={'main-contact'}
                                                                  checked={contact.main}
                                                                  onChange={(e) => handleMainParent(e.checked, k)}
                                                                  inputId={'main-contact-' + k}/>
                                                        <label htmlFor={'main-contact-' + k}
                                                               className={'m-l-5 m-b-0'}>Основной
                                                            контакт</label>
                                                    </div>
                                                </div>
                                                <div className="card-header card-header_r bg-default">
                                                    <Button type={'button'} onClick={(e) => handlerRemoveContact(e, k)}
                                                            icon={'pi pi-times'}
                                                            className={'p-button-text p-button-rounded p-button-danger'} text={true}/>
                                                </div>
                                                <div className="card-body d-flex flex-column gap-3">

                                                    <div className="row align-items-center">
                                                        <div className="col-md-12">
                                                            <FormGroup label={'Тип'}
                                                                       labelOptions={{className: 'p-float-label'}}
                                                                       horizontal>
                                                                <SelectButton options={[
                                                                    'мама', 'папа', 'бабушка', 'дедушка', 'водитель', 'другое'
                                                                ]} value={contact.type}
                                                                              onChange={(e) => formik.setFieldValue('contacts.' + k + '.type', e.target.value)}/>
                                                            </FormGroup>
                                                        </div>
                                                    </div>


                                                    <div className="row ">
                                                        <div className="col-md-6">
                                                            <FormGroup label={'ФИО'} horizontal error={getFormErrorMessage('contact_' + k + '_name', 'contacts.' + k + '.name')}>
                                                                <InputText value={contact.name} className=""
                                                                           onChange={(e) => formik.setFieldValue('contacts.' + k + '.name', e.target.value)}/>
                                                            </FormGroup>


                                                        </div>
                                                        <div className="col-md-6">
                                                            <FormGroup label={'Дата рождения'} horizontal>
                                                                <Calendar value={contact.birthday} className=""
                                                                          onChange={(e) => formik.setFieldValue('contacts.' + k + '.birthday', e.target.value)}/>
                                                            </FormGroup>
                                                        </div>
                                                    </div>


                                                    <div className={'row'}>
                                                        <div className="col-md-6">
                                                            <div className={' from-group form-group_horizontal'}>
                                                                <label htmlFor="">Телефон</label>
                                                                <div className={'d-flex flex-column gap-3'}>
                                                                    {contact.phones.map((phone, phoneKey) => {
                                                                        if (phone) {
                                                                            return (

                                                                                <div className="input-w-b">

                                                                                    <PhoneInput specialLabel={''}
                                                                                                value={phone.phone_code + phone.phone}
                                                                                                className=""
                                                                                                inputClass={'p-inputtext p-component '}
                                                                                                onChange={(e) => formik.setFieldValue('contacts.' + k + '.phones.' + phoneKey + '.phone', e)}/>
                                                                                    {phoneKey < 1 ?
                                                                                        <button type={'button'}
                                                                                                className={'btn '}
                                                                                                onClick={(e) => handlerAddContactPhone(k)}>
                                                                                            <i
                                                                                                className={'pi pi-plus'}></i>
                                                                                        </button>
                                                                                        :
                                                                                        <button type={'button'}
                                                                                                className={'btn '}
                                                                                                onClick={(e) => handlerRemoveContactPhone(k, phoneKey)}>
                                                                                            <i
                                                                                                className={'pi pi-times'}></i>
                                                                                        </button>
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        }
                                                                    })}
                                                                </div>
                                                                {getFormErrorMessage('contact_' + k + '_phone', 'contacts.' + k + '.phones.0.phone')}
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className={' from-group form-group_horizontal'}>
                                                                <label htmlFor="">Email</label>
                                                                <div className={'d-flex flex-column gap-3'}>
                                                                    {contact.emails.map((email, emailKey) => {
                                                                        if (email) {
                                                                            return (

                                                                                <div className="input-w-b">

                                                                                    <InputText specialLabel={''}
                                                                                               value={email.email}
                                                                                               className=""
                                                                                               inputClass={'p-inputtext p-component '}
                                                                                               onChange={(e) => formik.setFieldValue('contacts.' + k + '.emails.' + emailKey + '.email', e.target.value)}/>

                                                                                    {emailKey < 1 ?
                                                                                        <button type={'button'}
                                                                                                className={'btn '}
                                                                                                onClick={(e) => handlerAddContactEmail(k)}>
                                                                                            <i
                                                                                                className={'pi pi-plus'}></i>
                                                                                        </button>
                                                                                        :
                                                                                        <button type={'button'}
                                                                                                className={'btn '}
                                                                                                onClick={(e) => handlerRemoveContactEmail(k, emailKey)}>
                                                                                            <i
                                                                                                className={'pi pi-times'}></i>
                                                                                        </button>
                                                                                    }
                                                                                </div>


                                                                            )
                                                                        }
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 d-flex flex-column gap-3">
                                                            <FormGroup label={'Автомобиль'} horizontal>
                                                                <InputText value={contact.car_mark} className=""
                                                                           onChange={(e) => formik.setFieldValue('contacts.' + k + '.car_mark', e.target.value)}/>
                                                            </FormGroup>
                                                        </div>
                                                        <div className="col-md-6 d-flex flex-column gap-3">
                                                            <FormGroup label={'Номер автомобиля'} horizontal>
                                                                <InputText value={contact.car_number}
                                                                           className=""
                                                                           onChange={(e) => formik.setFieldValue('contacts.' + k + '.car_number', e.target.value)}/>
                                                            </FormGroup>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-6 d-flex flex-column gap-3">
                                                            <FormGroup label={'Место работы'} horizontal>
                                                                <InputText value={contact.work} className=""
                                                                           onChange={(e) => formik.setFieldValue('contacts.' + k + '.work', e.target.value)}/>
                                                            </FormGroup>

                                                        </div>
                                                    </div>


                                                </div>


                                            </div>

                                        )
                                    }
                                })}

                                <div>
                                    <Button className={'p-button-outlined'} type={'button'}
                                            label={'Добавить контактное лицо'} onClick={() => addContact()}/>
                                </div>


                            </div>
                            : <Loader/>}

                        {isLoading ? <Loader/> : ''}


                    </form>

                </div>

                <div className={'card-footer'}>
                    <Button form={'parents-form'} type={'submit'} label={'Сохранить'}/>
                </div>
            </div>
        </>
    )
}